import { DEFAULT_GUARANTEED_ANALYSIS } from "./constants";

function newAnalysisSection() {
    return {
        columnHeaders: [""],
        items: [],
    };
}

function newFootnoteSection() {
    return {
        items: [],
    };
}

function newIngredientsSection() {
    return {
        leadIn: "",
        items: [],
    };
}

export function createPanel() {
    return {
        ...DEFAULT_GUARANTEED_ANALYSIS,
        analysis: newAnalysisSection(),
        footnotes: newFootnoteSection(),
        ingredients: newIngredientsSection(),
    };
}
